import React, { useState } from "react";
import PipelinePage from "@/pages/Pipeline";
import ProposalGenerator from "@/pages/ProposalGenerator";
import MissionControlPage from "@/pages/MissionControlPage";
import { Kanban, FileText, Building2, Send, Radio } from "lucide-react";

/**
 * GrowPage — Phase 1 shell that consolidates the commercial workflow
 * surfaces under a single tabbed page per the REX v3 plan:
 * Pipeline · Proposals · Accounts · Outreach · Intelligence.
 *
 * In Phase 1 this just hosts existing pages under tabs (zero data risk).
 * Accounts + Outreach get full builds in Phase 6 / 8.
 */
const TABS = [
  { key: "pipeline", label: "Pipeline", icon: Kanban, comp: PipelinePage },
  { key: "proposals", label: "Proposals", icon: FileText, comp: ProposalGenerator },
  { key: "accounts", label: "Accounts", icon: Building2, comp: null },
  { key: "outreach", label: "Outreach", icon: Send, comp: null },
  { key: "intelligence", label: "Intelligence", icon: Radio, comp: MissionControlPage },
];

export default function GrowPage({ user }) {
  const [tab, setTab] = useState("pipeline");
  const Active = TABS.find((t) => t.key === tab);
  const Comp = Active?.comp;

  return (
    <div className="flex flex-col h-full" data-testid="grow-page">
      <div className="flex items-baseline justify-between px-6 pt-4">
        <h1 className="text-2xl font-bold text-slate-900">Grow</h1>
        <span className="text-xs text-slate-500">Where Revenue numbers get made</span>
      </div>
      <div className="flex gap-2 border-b border-slate-200 px-6">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              data-testid={`grow-tab-${t.key}`}
              className={`flex items-center gap-2 px-3 py-2 text-sm border-b-2 transition-colors ${
                active
                  ? "border-blue-600 text-blue-700 font-semibold"
                  : "border-transparent text-slate-500 hover:text-slate-800"
              }`}
            >
              <Icon className="h-4 w-4" />
              {t.label}
            </button>
          );
        })}
      </div>
      <div className="flex-1 overflow-auto" data-testid={`grow-pane-${tab}`}>
        {Comp ? (
          <Comp user={user} />
        ) : (
          <div className="p-8 text-sm text-slate-500">
            <p className="font-semibold text-slate-700 capitalize">{Active.label}</p>
            <p className="mt-1">
              Coming soon. The structure is agreed —
              {tab === "accounts" && " named-account plans with stakeholder maps, white-space, and 3-year revenue plans."}
              {tab === "outreach" && " Campaigns + Sequences + Templates + Briefs sub-tabs."}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
